// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2YtyU","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3FfJT","obliqueLine":"membershipbadge_obliqueLine__1o6W2"};